import { FormField } from '@weirgroup/weir-dls'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useDarkMode } from '../../../hooks/use-darkmode'
interface Props {
    list: any
    isEditing?: boolean
    setStockNumberValue?: Dispatch<SetStateAction<string>>
    setMachineNumberValue?: Dispatch<SetStateAction<string>>
}

export const GroupFormField = (props: Props) => {
    const { list, isEditing, setStockNumberValue, setMachineNumberValue } =
        props

    const [titles, setTitles] = useState<any>([])
    const [values, setValues] = useState<string[]>([])
    const {darkMode} = useDarkMode()
    const isFormFieldInEditMode = (itemTitle: string) =>{
        // Do new logic here: to replace the fieldChecker function
        if(itemTitle === 'stock number' || itemTitle === 'machine number')
            return !isEditing
        else
            return true
    }

    const handleOnChange = (event: any, item: string,itemId: any) => {
        if(values[itemId] !== "" || values[itemId] !== null){
            if(isEditing){
                let value = [...values]
                value[itemId] = event.target.value
                setValues(value)
                if (item == 'stock number' && setStockNumberValue) {
                    
                    setStockNumberValue(value[itemId])
                }

                if (item == 'machine number' && setMachineNumberValue) {
                    setMachineNumberValue(value[itemId])
                }
            }
        }
    }

    const convertToObject = (arr: any) => {
        let converted = arr.map((item: any, i: any) => ({
            title: item,
            id: i + 1,
        }))
        return converted
    }

    const getTitles = (list: any) => {
        let replacedTitles
        if (list.length == undefined) {
            const keys = Object.keys(list)
            replacedTitles = keys.map((item: any) => {
                if (item.includes('_')) {
                    const replaced = item.replace('_', ' ')
                    return replaced
                } else {
                    return item
                }
            })
        } else {
            replacedTitles = list
        }
        return convertToObject(replacedTitles)
    }

    useEffect(() => {
        setTitles(getTitles(list))
        setValues(Object.values(list))
    }, [])
    return (
        <div className='form-field-container'>
            {titles.map((item: any) => {
                return (
                    <FormField
                        darkMode={darkMode}
                        key={item.id}
                        name="InputBox"
                        label={item.title}
                        readonly={isFormFieldInEditMode(item.title)}
                        size={'sm'}
                        width={'100%'}
                        value={values[item.id - 1]}
                        fullWidth
                        onChange={(e: any) => handleOnChange(e, item.title,item.id-1)}
                        full
                        applyModalInternalGrid={true}
                        modalType={'large'}
                    />
                )
            })}
        </div>
    )
}
